<template>
  <div class="box-detail" :class="osg.has(`ExtForm/${colName},formMax`) ? 'form-max' : ''">
    <div class="box-left">
      <div class="box-left-header">
        <div @click="$router.go(-1)" class="goBack c-position-static c-m-0">
          <i class="el-icon-arrow-left"></i>
          <span>{{ formName }}</span>
        </div>
      </div>
      <div class="box-left-content">
        <c-form
          v-if="formShow"
          :formData="formData"
          :fields="extFields"
          :area="area"
          :options="options"
          :upload="upload"
          ref="form"
          :labelPosition="'top'"
          @changeForm="osg.changeForm"
        ></c-form>
      </div>
      <div class="box-left-footer" v-if="osg.has(`ExtForm/${colName},edit`)">
        <el-button type="primary" @click="doSave">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <div class="box-center">
      <el-tabs v-model="activeTab" @tab-click="osg.tabClick" class="c-h-1 c-flex c-flex-col">
        <template v-for="(ext, i) in subExts">
          <el-tab-pane :label="ext.title" :name="ext.colName" :key="i">
            <!-- TODO:仕高玛 机台档案-配件模板不允许增删改查 -->
            <div class="box-center-tool" v-if="ext._id != '3390038025393947414'">
              <div></div>
              <el-button type="primary" size="mini" @click="osg.subInit(true)">
                新建
              </el-button>
            </div>
            <div class="box-center-content">
              <el-table ref="table" :data="subData">
                <!-- 动态列 -->
                <c-table :fields="subFields" :options="options"></c-table>
                <el-table-column
                  fixed="right"
                  label="操作"
                  width="145"
                  v-if="ext._id != '3390038025393947414'"
                >
                  <template slot-scope="scope">
                    <el-button @click="osg.editExtForm(scope.row)" size="mini">编辑</el-button>
                    <el-button @click="osg.removeExtForm(scope.row)" size="mini">
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </template>
        <el-dialog
          :title="activeExt.title"
          :visible.sync="openExtDetail"
          destroy-on-close
          @closed="osg.subInit"
        >
          <c-form
            v-if="openExtDetail"
            :formData="subFormData"
            :fields="subFields"
            :options="options"
            ref="subFormData"
            :upload="upload"
          ></c-form>
          <div slot="footer">
            <el-button type="primary" @click="osg.saveExtForm(activeExt._id, subFormData)">
              确 定
            </el-button>
            <el-button @click="osg.subInit">取 消</el-button>
          </div>
        </el-dialog>
        <el-tab-pane label="业务动态" name="log" v-if="osg.has(`ExtForm/${colName},log`)">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">
                {{ log.content }}
              </div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.createUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="笔记" name="notes" v-if="osg.has(`ExtForm/${colName},note`)">
          <div class="box-center-tool">
            <div></div>
            <el-button
              type="primary"
              size="mini"
              @click="
                vqeditor.content = ``;
                openNote = true;
              "
            >
              创建笔记
            </el-button>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(note, i) in noteData" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  笔记
                </span>
                <span>{{ note.createTime }}</span>
              </div>
              <div
                class="activity-card-content-node"
                v-html="note.content"
                v-if="!note.openNote"
              ></div>
              <!-- <c-editor
                v-else
                class="c-m-15"
                :formData="note"
                :value="'content'"
                ref="editor"
              ></c-editor> -->
              <div class="activity-card-footer">
                <span>操作人：{{ note.createUserName }}</span>
              </div>
            </div>
          </div>
          <!-- markdown编辑器 -->
          <el-dialog title="笔记" :visible.sync="openNote" @close="vqeditor.content = ''">
            <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
            <div slot="footer">
              <el-button type="primary" @click="saveNote">确 认</el-button>
              <el-button
                @click="
                  openNote = false;
                  vqeditor.content = '';
                "
              >
                取 消
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>

        <el-tab-pane label="操作记录" name="history" v-if="osg.has(`ExtForm/${colName},history`)">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box-right" :class="collapse ? 'box-collapse' : ''" v-if="colName == 'vehicle'">
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse">
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1">
            <template slot="title">
              <span>工单</span>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of serviceAppointment.fpi.data" :key="i">
                <div>
                  <i class="el-icon-tickets card-item-logo"></i>
                </div>
                <div>
                  <p>工单编号： {{ item.orderNum }}</p>
                  <p>
                    <el-link
                      @click="osg.open('', '', '_blank', '/ServiceAppointment/' + item._id)"
                      target="_blank"
                    >
                      {{ item.title }}
                    </el-link>
                  </p>
                  <p>状态：{{ osg.codelabel('SAStatus', item.status) }}</p>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
export default {
  name: 'extFormDetail',
  data() {
    window.$this = this;
    return {
      id: null,
      colName: null,
      formName: null,
      extId: null,
      formData: { exts: {} },
      extFields: [],
      extField: {},
      fieldsObj: {},
      options: {
        codecfg_SAStatus: { codeId: 'STATUS' }
      },
      // 关联子表单
      subExts: [],
      activeExt: {},
      subFields: [], //子表单字段
      subFormData: { exts: {} },
      subData: [],
      openExtDetail: false,

      rules: this.$util.rules,
      // 地址级联
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      // 上传图片
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      collapse: false,
      activeNames: ['1'],
      activeTab: 'log',
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      // 笔记
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      // 操作记录
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      // 关联工单
      serviceAppointment: {
        fpi: { data: [] }
      },
      formShow: false
    };
  },
  mounted() {
    this.colName = this.osg.param('colName');
    this.id = this.osg.param('id');
    this.colName = this.osg.param('colName');
    this.osg.getFields(this.colName, () => {
      this.getData();
      this.getExtByColName();
      if (this.colName == 'vehicle') {
        this.getServiceAppointments();
      }
      this.osg.getSubExts(this.colName);
    });
  },
  methods: {
    getExtByColName() {
      this.osg.ajax('biz/ext/queryByColName/' + this.colName + '.do', {}, res => {
        this.formName = res.entity.title;
        this.extId = res.entity._id;
      });
    },
    getData() {
      this.osg.ajax(
        `biz/extForm/queryByColName/${this.colName}.do`,
        {
          _all: '1',
          _id: this.id
        },
        res => {
          this.formData = res.data[0] || {};
          this.formShow = true;
        }
      );
    },
    doSave() {
      if (this.osg.validate()) {
        this.osg.ajax(
          `biz/extForm/upsert/${this.extId}.do`,
          { dataStr: JSON.stringify(this.formData) },
          () => {
            this.osg.toast('保存成功！');
            this.getData();
          }
        );
      }
    },
    getServiceAppointments() {
      this.osg.ajax(
        'basic/serviceAppointment/query.do',
        {
          _all: '1',
          sortField: 'createTime',
          sortOrder: 'desc',
          'is:exts.assetsId|string#and': this.id
        },
        res => {
          this.serviceAppointment.fpi = res;
        },
        { noload: true }
      );
    },
    /**
     * 日志
     */
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: this.colName,
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    /**
     * 笔记
     */
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: this.colName,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.noteData = res || [];
        }
      );
    },
    saveNote() {
      var params = {
        sid: this.id,
        smodule: this.colName,
        content: this.vqeditor.content
      };
      debugger;
      this.osg.ajax('note/upsert.do', params, () => {
        this.osg.toast('保存成功！');
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    /**
     * 操作记录
     */
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res) {
            if (res.data.length > 0) {
              // 不需要展示变更的字段名
              res.data.filter(item => {
                item.modifyList = item.modifyList.filter(obj => {
                  return (
                    this.fieldsObj[obj.field] &&
                    this.fieldsObj[obj.field].showList.indexOf('6') != -1
                  );
                });
                return item.modifyList.length > 0;
              });
              this.historyFpi = res;
            }
          }
        },
        { noload: true }
      );
    }
  }
};
</script>
<style scoped lang="scss">
.form-max {
  .box-left {
    flex: 1;
    max-width: 100% !important;
  }
  .box-center {
    display: none;
  }
}
</style>
